import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=1f831267&scoped=true&"
import script from "./Favourite.vue?vue&type=script&lang=js&"
export * from "./Favourite.vue?vue&type=script&lang=js&"
import style0 from "./Favourite.vue?vue&type=style&index=0&id=1f831267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f831267",
  null
  
)

export default component.exports